function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
const ItemWrapper = _ref => {
  let {
    children,
    itemId = '',
    disabled = false,
    ariaAttributes = {},
    className = '',
    onClick = () => {},
    onKeyDown = () => {},
    measureRef
  } = _ref;
  /* eslint-disable jsx-a11y/role-has-required-aria-props */
  return /*#__PURE__*/React.createElement("li", _extends({
    ref: measureRef,
    id: `treeItem-${itemId}`,
    className: `${treeStyles['sib-tree-view__item']} ${className}`,
    role: "treeitem",
    disabled: disabled,
    style: disabled ? {
      pointerEvents: 'none',
      cursor: 'not-allowed'
    } : {},
    tabIndex: disabled ? -1 : 0,
    onClick: onClick,
    onKeyDown: e => {
      onKeyDown(e);
    }
  }, ariaAttributes), children);
};
ItemWrapper.propTypes = {
  children: PropTypes.node,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  ariaAttributes: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  measureRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }), PropTypes.shape({
    current: PropTypes.instanceOf(Component)
  })])
};
export default ItemWrapper;